import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { SchoolScheduleDatabase } from './school-schedule-database';
import { EventDto } from '../../../../models/event/event';

export class SchoolScheduleDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    _shiftId = -1;
    filteredData: EventDto[] = [];
    renderedData: EventDto[] = [];
    dataLength = 0;

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    constructor(
        private schoolScheduleDatabase: SchoolScheduleDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort,
        private _shiftSelected) {
        super();
        this._shiftId = _shiftSelected;
        // Reset to the first page when the store changes the filter.
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<EventDto[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this.schoolScheduleDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            // Filter data
            this.filteredData = this.schoolScheduleDatabase.data.slice().filter((item: EventDto) => {
                if (item.Title !== undefined) {
                    const searchStr = (item.Title).toLowerCase();
                    return searchStr.indexOf(this.filter.toLowerCase()) !== -1 && (this._shiftId === -1 || item.ShiftId === this._shiftId);
                }
                console.log('item>>>>>>', item);
            });

            // Sort filtered data
            // const sortedData = this.sortData(this.filteredData.slice());
            const sortedData = this.filteredData.slice();

            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            this.dataLength = this.schoolScheduleDatabase.data.length;
            return this.renderedData;
        });
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: EventDto[]): EventDto[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }
        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';
            switch (this._sort.active) {
                case 'Name':
                    [propertyA, propertyB] = [a.Title, b.Title];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    filterSchedule(shiftId){
        this._shiftId = shiftId;
        this._filterChange.next(this.filter);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/events/school-schedule/school-schedule-data-source.ts